import { render } from "./Setting.vue?vue&type=template&id=eddd8c5a&scoped=true&ts=true"
import script from "./Setting.vue?vue&type=script&setup=true&lang=ts"
export * from "./Setting.vue?vue&type=script&setup=true&lang=ts"

import "./Setting.vue?vue&type=style&index=0&id=eddd8c5a&lang=scss&scoped=true"

import exportComponent from "/Users/luoke/Desktop/新开发代码_git/h5-jalalive/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eddd8c5a"],['__file',"src/views/me/Setting.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "eddd8c5a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('eddd8c5a', __exports__)) {
    console.log('reload')
    api.reload('eddd8c5a', __exports__)
  }
  
  module.hot.accept("./Setting.vue?vue&type=template&id=eddd8c5a&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('eddd8c5a', render)
  })

}


export default __exports__